import React from "react";
import PropTypes from "prop-types";

function FilterBox({
  filters,
  setFilter,
  active,
  small = false,
  border = false,
}) {
  return (
    <div
      className={`filter-box ${small ? "small" : ""} ${border ? "border" : ""}`}
    >
      {filters.map((item, index) => (
        <small
          key={index}
          onClick={() => setFilter(item)}
          className={`fw-bolder ${active.type === item.type ? "active" : ""}`}
        >
          {item.icon && <i className={item.icon}></i>}
          {item.name && `${item.name}`}
        </small>
      ))}
    </div>
  );
}

FilterBox.propTypes = {
  filters: PropTypes.array.isRequired,
  setFilter: PropTypes.func.isRequired,
  active: PropTypes.object.isRequired,
  small: PropTypes.bool,
  border: PropTypes.bool,
};

export default FilterBox;
